import _ from "lodash";

import AmpersandState from 'ampersand-state';

const TodoListTemplateModel = AmpersandState.extend({

    idAttribute: 'id',

    props: {
        id: 'string',
        companyId: 'string',
        name: 'string',
        sortPosition: 'number',
        todoList: 'object' // array of json
    },

    parse(obj) {
        if (!obj.todoList) obj.todoList = [];
        return obj;
    },

});

module.exports = TodoListTemplateModel;